import axiosInstance from "./axiosInstance";

export const submitFeedback = async (data) => {
  const formData = new FormData();

  formData.append("type", data.type);
  formData.append("title", data.title || "");
  formData.append("description", data.description);
  formData.append("page_url", data.page_url);
  formData.append("brand_id", data.brand_id);
  formData.append("brand_name", data.brand_name);
  formData.append("user_id", data.user_id);
  formData.append("user_email", data.user_email);
  formData.append("timestamp", data.timestamp);
  formData.append("screen_resolution", data.screen_resolution);

  // Add file attachments
  if (data.attachments && data.attachments.length > 0) {
    data.attachments.forEach((file) => {
      formData.append("attachments", file);
    });
  }

  const response = await axiosInstance.post("/feedback/submit", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};
